<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.phone"
              placeholder="请输入电话号码"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @sureBill="sureBillFun(arguments)"
        />
      </div>
      <!-- 认证 -->
      <sure-dialog
        :data-id="selectId"
        :dialog-title="'确认关联零售户'"
        :dialog-visible.sync="dialogSureVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 认证
import sureDialog from './sureDialog'
import { loadAppUserListDataApi } from '@/api/appUser'
export default {
  name: 'SureAppUserList',
  components: { CustomTable, sureDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'sure_app_user_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'sure',
            label: '认证',
            method: 'sureBill'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            phone: '',
            type: 1,
            status: 1
          }
        }
      },
      isPaging: true,
      dialogSureVisible: false,
      selectId: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.initTableColumn = [
          { prop: 'rowNumber', label: '序号', width: 80 },
          { prop: 'name', label: '名称', width: 120 },
          { prop: 'phone', label: '电话', width: 120 },
          { prop: 'provinceName', filterColumn: 'province_name', label: '省区', width: 120 },
          { prop: 'cityName', filterColumn: 'city_name', label: '省区', width: 120 },
          { prop: 'storeName', filterColumn: 'store_name', label: '店名', width: 120 },
          { prop: 'certificateNo', filterColumn: 'certificate_no', label: '专卖证号', width: 160 },
          { prop: 'benxiangStoreNo', filterColumn: 'benxiang_store_no', label: '本香门店码', width: 160 },
          { prop: 'createDateStr', filterColumn: 'create_date', label: '注册日期', width: 120 },
          { prop: 'statusStr', filterColumn: 'status', filterValue: 'status', label: '状态', width: 200, filterArray: [{ label: '未认证', value: 1 }, { label: '停用', value: 2 }, { label: '已认证', value: 3 }] },
          { prop: 'remark', label: '备注', width: 200 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadAppUserListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 认证
    sureBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else {
        this.selectId = args[0].id
        this.dialogSureVisible = !this.dialogSureVisible
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
